import faqHome from '../pages/support/index.vue';
import newFaq from '../pages/support/new_faq.vue';
import editFaq from '../pages/support/edit_faq.vue';
import Faq_categories from "@/pages/support/faq_categories.vue";

const routes = [
  { // faq
    path: 'faq',
    name: 'faq',
    component: faqHome,
    meta:{
      name: 'FAQ',
      requireAuth: true
    },
  },
  { // new_faq
    path: 'new_faq',
    name: 'new-faq',
    component: newFaq,
    meta:{
      name: 'New FAQ',
      requireAuth: true
    },
  },
  { // edit_faq/:id
    path: 'edit_faq/:id',
    name: 'edit-faq',
    component: editFaq,
    meta:{
      name: 'Edit FAQ',
      requireAuth: true
    },
  },
  { // faq/categories
    path: 'faq/categories',
    name: 'faq-categories',
    component: Faq_categories,
    meta:{
      name: 'New FAQ',
      requireAuth: true
    },
  },
]

export default routes